import { colors } from "../../tokens";
export var alertColors = {
  background: {
    info: colors.blue[40],
    critical: colors.red[40],
    success: colors.green[40],
    warning: colors.yellow[40]
  },
  icon: {
    info: colors.blue[10],
    critical: colors.red[10],
    success: colors.green[10],
    warning: colors.yellow[10]
  }
};